<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="380">
      <v-card>
        <v-card color="blue">
          <v-card-title class="white--text subheading">{{ $t('BUTT_DIALOG_LEAVE_TITLE', { type: item.type, id:item.id }) }}</v-card-title>
        </v-card>
        <v-card-text>
          <v-layout justify-start row wrap>
            <v-flex md12>
              {{ 'BUTT_DIALOG_LEAVE_TEXT' | translate}}
            </v-flex>
            <v-flex md12>
              <!--{{item.name}}-->
            </v-flex>
          </v-layout>


        </v-card-text>
        <v-card-actions>
          <v-btn color="#004884" small outline class="text-none" flat @click="dialog = false">{{ 'BUTT_CANCEL' | translate}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" dark small class="text-none" @click="deleteItem()">{{ 'BUTT_DIALOG_LEAVE_PEERGROUP' | translate}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  export default {
    name: 'DialogOpenlink',
    components: {},
    methods: {
      open: function (item) {
        this.dialog = true
        this.item = item
      },
      deleteItem: function () {
        this.dialog = false
        this.$emit('doDialogOpenlink', this.item)
      }
    },
    data () {
      return {
        dialog: false,
        item: {}
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogOpenLink.vue